module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('spr-dialog', {
    attrs: {
      "name": "permissions",
      "show": _vm.show,
      "title": _vm.title
    },
    on: {
      "confirm": _vm.handleConfirm,
      "open": _vm.handleOpen,
      "update:show": function (flag) { return this$1.$emit('update:show', flag); }
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contactName),
      expression: "contactName"
    }],
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_vm._v("给联系人：【"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.contactName))]), _vm._v("】分配账户及权限")]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin": "0 50px"
    },
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    staticClass: "bold"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "sub-form",
    attrs: {
      "model": _vm.Form,
      "rules": _vm.Rules,
      "label-suffix": "：",
      "inline": true,
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分部",
      "prop": "PartnerRegionId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "280px",
      "margin-right": "400px"
    },
    model: {
      value: (_vm.Form.PartnerRegionId),
      callback: function($$v) {
        _vm.Form.PartnerRegionId = $$v
      },
      expression: "Form.PartnerRegionId"
    }
  }, _vm._l((_vm.Companys), function(Company) {
    return _c('el-option', {
      key: Company.Id,
      attrs: {
        "label": Company.Name,
        "value": Company.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登录账户",
      "prop": "Name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "280px"
    },
    model: {
      value: (_vm.Form.Name),
      callback: function($$v) {
        _vm.Form.Name = $$v
      },
      expression: "Form.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "100px"
    },
    attrs: {
      "label": "设置登录密码",
      "prop": "Password"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "280px"
    },
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.Form.Password),
      callback: function($$v) {
        _vm.Form.Password = $$v
      },
      expression: "Form.Password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bold",
    attrs: {
      "label": "权限选择"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.Form.Permissions),
      callback: function($$v) {
        _vm.Form.Permissions = $$v
      },
      expression: "Form.Permissions"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/entrust"
    }
  }, [_vm._v("委托查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/lease"
    }
  }, [_vm._v("租赁查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/inventory"
    }
  }, [_vm._v("库存查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/repair"
    }
  }, [_vm._v("维修查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/logistics"
    }
  }, [_vm._v("物流信息查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/financial"
    }
  }, [_vm._v("结算查询")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/order"
    }
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "/profile/info"
    }
  }, [_vm._v("个人中心")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02a01a32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ProfilePage/PermissionsDialog.vue
// module id = 695
// module chunks = 0